import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=32fbb831&scoped=true"
import script from "./Identification.vue?vue&type=script&lang=js"
export * from "./Identification.vue?vue&type=script&lang=js"
import style0 from "./Identification.vue?vue&type=style&index=0&id=32fbb831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fbb831",
  null
  
)

export default component.exports